<template>
    <ac-modal :title="patient" ref="modal">
        <template>
            <div v-if="contracts.length>0" class="row">
                <div class="col-md-12">
                    <div class="alert alert-warning">
                        <p>The following contracts have not been signed:</p>
                        <br>
                        <div v-for="c in contracts">
                            <p>
                                * &nbsp; {{c.contractName}} - {{c.owner}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "PatientAgreementsDetails",
        props: {providerEntityId: {type: [Number], required: true}},
        data() {
            return {
                patient: '',
                contracts: []
            };
        },
        methods: {
            async showModal(consumerId) {
                let [patient, contracts] = await Promise.all([
                    api.getDataWithTwoIds('Shared', this.providerEntityId, 'GetPatientBasicInfo', consumerId),
                    api.getDataWithTwoIds('ProviderContracts', this.providerEntityId, 'GetUnsignedContracts', consumerId)
                ]);
                this.patient = `${patient.firstName} ${patient.lastName}`;
                this.contracts = contracts;
                this.$refs.modal.open();
            }
        }
    }
</script>

<style scoped>

</style>